import { Injectable, signal } from '@angular/core';
import { TickerItem } from '../models/ticker-item.model';

/**
 * Shared with the root app shell so the bottom ticker bar (rendered outside the router
 * outlet, pinned to the dashboard content area) can react to range changes made inside
 * DashboardComponent without the two being directly related in the component tree.
 */
@Injectable({ providedIn: 'root' })
export class DashboardTickerService {
  readonly items = signal<TickerItem[]>([]);
  readonly loading = signal(true);
}
